import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faDice, faFire, faGlobeAmericas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import VueToast from 'vue-toast-notification'

import 'vue-toast-notification/dist/theme-sugar.css';

Vue.config.productionTip = false;

const config = {
  api_url: "https://api.embersadrift.com",
  login_url: "https://forums.embersadrift.com/login",
  youtube_code: "",
  shop_open: true,
  maint_mode: false
};

config.install = function () {
  Object.defineProperty(Vue.prototype, '$config', {
    get() { return config }
  })
};

Vue.use(config);

let currentUser = { user_id: 0 };
currentUser.install = function () {
  Object.defineProperty(Vue.prototype, '$currentUser', {
    get() { return currentUser },
    set(val) { currentUser = val; }
  });
};

Vue.use(currentUser);

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm');
  }
});

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueCookies);
Vue.use(VueAxios, axios);
Vue.use(VueToast, {
  position: 'top-right'
});

library.add(faGlobeAmericas);
library.add(faFire);
library.add(faDice);
Vue.component('font-awesome-icon', FontAwesomeIcon);

export const bus = new Vue();

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');


